import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { NotFoundError } from 'src/shared/error';

import type { PaginatedContextData, PaginatedData } from 'src/app/shared/contexts/asyncData';

import { TopicVictoriousPetitions } from './api.graphql';
import type { TopicVictoriousPetitionsQuery, TopicVictoriousPetitionsQueryVariables } from './api.graphql';
import type { TopicVictoriousPetitionsItem } from './types';

type TopicVictoriousPetitionsApiData = PaginatedData<
	TopicVictoriousPetitionsItem,
	{
		totalCount: number;
		totalCountLocalized: string;
	}
>;

export type TopicVictoriousPetitionsData = PaginatedContextData<TopicVictoriousPetitionsApiData>;

async function getData(
	{ gql: { fetch } }: UtilityContext,
	slug: string,
	cursor?: string,
): Promise<TopicVictoriousPetitionsApiData> {
	const { data } = await fetch<TopicVictoriousPetitionsQuery, TopicVictoriousPetitionsQueryVariables>({
		query: TopicVictoriousPetitions,
		variables: { slug, cursor: cursor ?? null },
		rejectOnError: true,
	});

	if (!data.topicPage) throw new NotFoundError();

	return {
		items: data.topicPage.victoriousPetitionsConnection.nodes,
		cursor: data.topicPage.victoriousPetitionsConnection.pageInfo.endCursor,
		hasNextPage: data.topicPage.victoriousPetitionsConnection.pageInfo.hasNextPage,
		totalCount: data.topicPage.victoriousPetitionsConnection.totalCount,
		totalCountLocalized: data.topicPage.victoriousPetitionsConnection.totalCountLocalized,
	};
}

export async function getFirstPageData(utilityContext: UtilityContext, slug: string) {
	return getData(utilityContext, slug);
}

export async function getNextPageData(utilityContext: UtilityContext, cursor: string, slug: string) {
	return getData(utilityContext, slug, cursor);
}
